import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material';
import { CMSContent } from '../../containers/cmscontent/CMSContent';

const useStyles = makeStyles()((theme: Theme) =>
    ({
        container: {
            padding: theme.spacing(3)
        }
    }));



export const TermsOfUsePage = () => {
    const { classes } = useStyles();
    return <div className={classes.container}> <CMSContent type={'contentitem'} name={'terms-of-use'} /></div>;
  };